import React, { useState } from "react";

import Button from "../../Button";
import Label from "../../Label";
import Title from "../../Title";

import { numberWithCommas } from "../../../util";
import { CloseWhiteIcon, DetailIcon } from "@assets/svgs";
import { Loader } from "../../Loader";

import "./style.scss";

export function ProjectMetrics({
  avg_project_size,
  avg_project_duration,
}) {
  const [showIntro, setShowIntro] = useState(false);

  const isLoading = !avg_project_size && !avg_project_duration;

  const onToggle = () => {
    setShowIntro(!showIntro);
  };

  return (
    <div className="project-metrics" data-aos="fade-up" data-aos-delay="50">
      <div className="project-metrics__overlay" />
      <div
        className={`project-metrics__main project-metrics__main--${
          showIntro ? 'hide' : 'show'
        }`}
      >
        <div className="project-metrics__header">
          <Title type="white" size="small" font="medium">
            Braintrust project metrics
          </Title>
          <Button onClick={onToggle}>
            <DetailIcon className="icon__detail" />
          </Button>
        </div>
        {isLoading && <Loader variant="light" className="allocation__loader" />}
        {!isLoading && (
          <div className="project-metrics-container project-metrics__content">
            <div>
              <Label type="white" size="large">
                Average Project Size
              </Label>
              <p className="project-metrics-container__dollar-amount">
                ${numberWithCommas(Math.floor(avg_project_size))}
              </p>
            </div>
            <div className="project-metrics__mt-108">
              <Label type="white" size="large">
                Average Project Duration
              </Label>
              <p className="project-metrics-container__dollar-amount">{avg_project_duration ?? 0} days</p>
            </div>
          </div>
        )}
      </div>
      <div
        className={`project-metrics__intro project-metrics__intro--${
          showIntro ? 'show' : 'hide'
        }`}
      >
        <div className="project-metrics__header">
          <Title type="white" size="medium" font="medium">
            Definitions
          </Title>
          <Button onClick={onToggle}>
            <CloseWhiteIcon className="icon__detail" />
          </Button>
        </div>
        <div className="project-metrics__mt-50">
          <div className="project-metrics__mt-50">
            <Label size="large" type="white" font="medium">
              Average Project Size
            </Label>
            <br />
            <Label size="medium" type="white">
              This metric uses previously submitted invoices. Average Project size is calculated by the number of weeks
              of a project x hrs/week x hourly rate.
            </Label>
          </div>
          <div className="project-metrics__mt-50">
            <Label size="large" type="white" font="medium">
              Average Project Duration
            </Label>
            <br />
            <Label size="medium" type="white">
              This metric is pulled based on the number of active and completed projects. The start date is set when an
              offer is made to talent, and the end date is calculated based on when the project is marked as complete,
              or the anticipated end date. We average the total project duration, and round to the nearest half month.
            </Label>
          </div>
        </div>
        <div />
      </div>
    </div>
  );
}
